module.exports = __webpack_public_path__ + "assets/img/tab2.5b3a8afa.png";